import {FormControl} from 'react-bootstrap'
import styles from './common.module.css'


const Search = ({
    type,
    placeholder,
    value,
    onChange,
    refValue,
    name,
    onKeyDown,
    onBlur,
    title,
    disabled = false
  }) => {
  return(
    <>
    <div className={styles.title}>{title}</div>
    <FormControl
    className={styles.searchInput}
    type={type}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    ref={refValue}
    name={name}
    onKeyDown={onKeyDown}
    disabled={disabled}
    />
    </>
  )
}

export default Search